/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, { Component } from 'react';

import { history } from '../../state/store';

import GroupApi from '../../api/group';
import OrganizationDetails from './OrganizationDetails';
import OrganizationsList from './OrganizationsList';
import Subnav from '../subnav';

import withEhsPageBehavior from '../../withEhsPageBehavior';

class ManageOrganizationsPage extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            organizations: [],
            selected: null,
        };

        this.loadOrganizations = this.loadOrganizations.bind(this);
        this.patchOrganization = this.patchOrganization.bind(this);
        this.selectOrganization = this.selectOrganization.bind(this);
    }

    componentDidMount() {
        this.loadOrganizations();
    }

    patchOrganization(organization) {
        let orgs = this.state.organizations;
        let idx = -1;
        orgs.forEach((org, i) => {
            if (org.id === organization.id) {
                idx = i;
            }
        });
        let newOrgs = this.state.organizations.slice(0); // clone
        if (idx >= 0) {
            newOrgs[idx] = organization;
        }
        this.setState({ organizations: newOrgs });
    }

    selectOrganization(org) {
        this.setState({ selected: org });
    }

    loadOrganizations() {
        GroupApi.getOrganizations()
            .then(orgs => {
                let selected = null;
                if (orgs && orgs.length >= 1) {
                    selected = orgs[0];
                }
                this.setState({
                    organizations: orgs,
                    selected: selected,
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({
                    organizations: [],
                });
            });
    }

    render() {
        const { organizations, selected } = this.state;

        return (
            <div className="page">
                <div className="page__subnav">
                    <Subnav />
                </div>
                <div className="masterdetailspage">
                    <div className="masterdetailspage__master">
                        <h2>
                            <i className="fa fa-sitemap"></i> Organizations
                        </h2>
                        <OrganizationsList
                            organizations={organizations}
                            selected={selected}
                            onSelection={this.selectOrganization}
                        />

                        <a
                            className=""
                            onClick={() => {
                                history.push('/consultant/organizations/new');
                            }}>
                            <i className="fa fa-plus"></i>
                            &nbsp; Add a new organization
                        </a>
                    </div>

                    <div className="masterdetailspage__details">
                        <OrganizationDetails
                            organization={selected}
                            onDelete={this.loadOrganizations}
                            onUpdate={this.patchOrganization}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withEhsPageBehavior(ManageOrganizationsPage);
